<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    name: 'SurveyQuestionOption',
    mixins: [curd],
    props: ['defaultParams'],
    data() {
      return {
        url: '/survey/question/option',
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增项目', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中x
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '选项名称',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left',
              rules: [{
                required: true, message: '请输入名称', trigger: 'blur'
              }]
            },
            {
              label: '选项图片',
              prop: 'filepaths',
              // dataType: 'string', // 单图不要此属性
              // hide: true,
              type: 'upload',
              listType: 'picture-img', // 单图
              // listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
            {
              label: '选中次数',
              display: false,
              prop: 'num',
              type: 'number'
            },
          ]
        }
      }
    }
  }
</script>
